// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__1Ptgb","title":"List_title__21qg3","placeholder":"List_placeholder__2F8CD","placeholder-item":"List_placeholder-item__2ca6Q"};